module.exports = __webpack_public_path__ + "img/Feature.4d284035.png";